import React from 'react'
import Principal from '../../components/cards/Principal'
import Categories from '../../components/containers/Categories'


export default function Category() {
  return (
    <div>
       <Categories />
       <Principal />
    </div>
  )
}
